import { TranslationKey, translationKey, unsafeTranslationKey } from 'intl/types/translationKey';
import type { EntityNotFoundTitleSlug, EntityNotFoundInfoSlug, EntityRemovedSlug } from 'intl/generated/translationKeySlugs';
import { isEntityNotFoundInfoSlug } from 'intl/generated/translationKeySlugs';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const EntityTranslationKeys = {
  notFoundDocumentInfo: translationKey('entity_not_found_document_info'),
  notFoundDocumentTitle: translationKey('entity_not_found_document_title'),
  notFoundEventInfo: translationKey('entity_not_found_event_info'),
  notFoundEventTitle: translationKey('entity_not_found_event_title'),
  notFoundIssueInfo: translationKey('entity_not_found_issue_info'),
  notFoundIssueTitle: translationKey('entity_not_found_issue_title'),
  notFoundLevelInfo: translationKey('entity_not_found_level_info'),
  notFoundLevelTitle: translationKey('entity_not_found_level_title'),
  notFoundProcessInfo: translationKey('entity_not_found_process_info'),
  notFoundProcessTitle: translationKey('entity_not_found_process_title'),
  notFoundProjectInfo: translationKey('entity_not_found_project_info'),
  notFoundProjectTitle: translationKey('entity_not_found_project_title'),
  notFoundReportTitle: translationKey('entity_not_found_report_title'),
  notFoundSiteInfo: translationKey('entity_not_found_site_info'),
  notFoundSiteTitle: translationKey('entity_not_found_site_title'),
  notFoundTemplateInfo: translationKey('entity_not_found_template_info'),
  notFoundTemplateTitle: translationKey('entity_not_found_template_title'),
  removedDocument: translationKey('entity_removed_document'),
  removedEvent: translationKey('entity_removed_event'),
  removedIssue: translationKey('entity_removed_issue'),
} as const satisfies Record<string, TranslationKey>;

export function entityNotFoundTitleKey(entity: EntityNotFoundTitleSlug): TranslationKey {

  return unsafeTranslationKey(`entity_not_found_${entity}_title`);

}

export function entityNotFoundInfoKey(entity: EntityNotFoundInfoSlug): TranslationKey {

  return unsafeTranslationKey(`entity_not_found_${entity}_info`);

}

export function entityRemovedKey(entity: EntityRemovedSlug): TranslationKey {

  return unsafeTranslationKey(`entity_removed_${entity}`);

}

export function toEntityNotFoundSlug(value: string | undefined): EntityNotFoundInfoSlug {

  if (value !== undefined && isEntityNotFoundInfoSlug(value)) {

    return value;

  }

  return 'issue';

}
